import { Component, OnInit } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
@Component({
  selector: 'app-authentication-layout',
  templateUrl: './authentication-layout.component.html',
  styleUrls: ['./authentication-layout.component.scss'],
      providers: [OrderPipe] // Add this line
})
export class AuthenticationLayoutComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }
}
